import React from 'react';
import { useTranslation } from 'react-i18next';
import valueReduceImg from 'assets/images/saveThePlanet/value-reduce.svg';
import valueReuseImg from 'assets/images/saveThePlanet/value-reuse.svg';
import valueRepurposeImg from 'assets/images/saveThePlanet/value-repurpose.svg';
import ValuesListSection from '../../components/commons/ValuesListSection';

const GivingSecondLifeSection = () => {
  const { t } = useTranslation('saveThePlanet');

  return (
    <ValuesListSection
      header={t('giving-second-life.header')}
      values={[
        {
          image: valueReduceImg,
          width: 143,
          title: t('giving-second-life.value-reduce.header'),
          description: t('giving-second-life.value-reduce.description'),
        },
        {
          image: valueReuseImg,
          width: 165,
          title: t('giving-second-life.value-reuse.header'),
          description: t('giving-second-life.value-reuse.description'),
        },
        {
          image: valueRepurposeImg,
          width: 146,
          title: t('giving-second-life.value-repurpose.header'),
          description: t('giving-second-life.value-repurpose.description'),
        },
      ]}
    />
  );
};

export default GivingSecondLifeSection;
